import { ReactNode } from 'react';
import { BORDER_RADIUSES, SPACINGS } from 'shared/styles/variables';
import styled from 'styled-components';

import Button from 'design-system/components/Button';
import Input, { InputProps } from 'design-system/components/Input';

const InputAndButton = styled('div')`
  position: relative;
  height: 40px;
  border-radius: ${BORDER_RADIUSES.base};
`;

const StyledInput = styled(Input)`
  width: 100%;
  height: 100%;
  border-right: none;
  padding-right: ${SPACINGS.base * 14}px;
`;

const AddButton = styled(Button)`
  position: absolute;
  right: 0;
  top: 0;
  bottom: 0;
  width: ${SPACINGS.base * 13}px;
  height: 100%;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  transform: none !important;
`;

interface InputWithActionProps extends InputProps {
  id?: string;
  'data-test'?: string;
  actionLabel?: ReactNode;
  onSubmit?: () => void;
}

const InputWithAction = ({
  id,
  'data-test': dataTest,
  disabled,
  value,
  actionLabel = 'Add',
  onSubmit,
  ...passthroughProps
}: InputWithActionProps) => {
  return (
    <InputAndButton>
      <StyledInput {...passthroughProps} id={id} disabled={disabled} />
      <AddButton
        id={`${id}-submit`}
        data-test={dataTest}
        disabled={disabled}
        type='button'
        onClick={onSubmit}
      >
        {actionLabel}
      </AddButton>
    </InputAndButton>
  );
};

export default InputWithAction;
